import React from 'react'

function VerifyEmail() {
  return (
    <div>VerifyEmail</div>
  )
}

export default VerifyEmail